<script lang="ts">
  import type { App } from '$lib/types';
  import { MetafyPartnerEnum } from '$lib/types/api/graphql';

  import { createEventDispatcher, getContext } from 'svelte';
  import { getApolloClient, gql } from '$lib/apollo';
  import { page } from '$app/stores';
  import { uuidv4 } from '$lib/utils';

  import Tag from '$mds/Tag/Tag.svelte';
  import PricingCard from './PricingCard.svelte';
  import FormControl from '$components/FormControl.svelte';
  import { openAuthModal } from '$routes/auth/account/_components/AuthModal.svelte';
  import { openCheckoutDrawer } from '$components/Pro/modals/CheckoutDrawer.svelte';

  const { isLoggedIn, isPartner, isPro, isCore } = getContext<App>('app');

  const dispatch = createEventDispatcher();

  let isYearly = true;
  let referrerAccount: null | any = null;

  let className = '';
  export { className as class };

  function openCheckout(plan) {
    if (!$isLoggedIn) {
      openAuthModal({
        prompt: {
          title: 'Hold that thought',
          description: 'You can become a Partner once you sign up or sign into your account!'
        },
        callback: async () => {
          if ($page.url.searchParams.has('ref') && referrerAccount && referrerAccount.id) {
            referralClickTrack();
          }

          openCheckoutDrawer({
            plan,
            isYearly,
            onUnlocked: () => dispatch('unlocked')
          });
        }
      });
      return;
    }

    openCheckoutDrawer({
      plan,
      isYearly,
      onUnlocked: () => dispatch('unlocked')
    });
  }

  async function referralClickTrack() {
    // Check if we've already stored the anonymous sessionId in localStorage:
    let sessionId = localStorage.getItem('metafyReferralSessionId');
    if (!$isLoggedIn && !sessionId) {
      // If not, generate a new one and store it, if the user isn't logged in;
      // If they are logged in, it's not needed:
      sessionId = uuidv4();
      localStorage.setItem('metafyReferralSessionId', sessionId);
    }

    const identifier = $page.url.searchParams.get('ref');

    await getApolloClient().mutate({
      mutation: gql`
        mutation ReferralClickTrack($input: ReferralClickTrackInput!) {
          referralClickTrack(input: $input) {
            errors {
              ... on Error {
                code
                message
              }
            }
          }
        }
      `,
      variables: {
        input: {
          identifier,
          sessionId
        }
      }
    });
  }
</script>

<div class={className}>
  <div class="flex justify-center">
    <label
      for="toggle-pricing-period"
      class="border-ondark-subtle relative flex cursor-pointer items-center gap-3 rounded-md border px-3.5 py-3"
    >
      <span class="text-body-xs text-ondark-primary">Monthly</span>
      <FormControl id="toggle-pricing-period" class="isolate" type="toggle" bind:checked={isYearly} />
      <span class="text-body-xs text-ondark-primary">Yearly</span>
      <Tag variant="positive" size="md">Save 33%</Tag>
    </label>
  </div>

  <div class="mt-10 flex flex-col gap-4 lg:grid lg:grid-cols-2">
    <div class="">
      <PricingCard
        plan={MetafyPartnerEnum.Core}
        {isYearly}
        isRecommended={$isCore}
        on:planClick={() => openCheckout(MetafyPartnerEnum.Core)}
      />
    </div>

    <div class="order-1 lg:order-none">
      <PricingCard
        plan={MetafyPartnerEnum.Pro}
        {isYearly}
        isRecommended={!$isPartner || $isPro}
        on:planClick={() => openCheckout(MetafyPartnerEnum.Pro)}
      />
    </div>

    <!-- <div class="">
      <PricingCard plan={MetafyPartnerEnum.Ultra} {isYearly} isRecommended on:planClick />
    </div> -->
  </div>
</div>
